import(/* webpackMode: "eager" */ "/home/ubuntu/cgc-blog/app/global-error.tsx")